import {deepdash, Fragment, observable, observer, React, useAsObservableSource} from '@api'
import {LayoutStore, RowNode, Splitter, SplitterNode, TabNode, useLayoutStore} from '@flexlayout'
import {computed} from 'mobx'
//import * as css from './Splitters.css'

/// region Store

export class SplittersStore {
  constructor(public store: LayoutStore) {
  }

  @computed get rows() {
    const {store: {model: {_idMap}}} = this

    return _.values(_idMap).filter(v => v instanceof RowNode) as RowNode[]
  }

  @computed get splitters() {
    const {rows} = this

    return _.flatMap(rows.map(r => r.drawChildren.filter(c => c instanceof SplitterNode))) as SplitterNode[]
  }

  get model() { return this.store.model}

  // @computed get borderSplitterNodes(): Array<SplitterNode> {
  //   const {store: {props: {model: {borderSet}}}} = this
  //
  //   return _.flatMap(borderSet.borders.filter(b => b.isShowing).map(b => b.drawChildren.filter(child => child instanceof SplitterNode))) as SplitterNode[]
  // }
  //
  // @computed get mainSplitterNodes() {
  //   const {model: {root}} = this
  //
  //   return deepdash.filterDeep(root.drawChildren, (value, key, parent) => {
  //     return parent instanceof SplitterNode
  //   })
  // }
}

/// endregion

/// region Components

interface MyProps {

}

export const Splitters = observer<MyProps>(function Splitters({...props}) {
  const store = useLayoutStore(),
    {splitters: {splitters}} = store

  return (
    <Fragment>
      {splitters.map(node => <Splitter key={node.id} layout={store} node={node}/>)}
    </Fragment>)
})

/// endregion



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/view/Layout/Splitters.tsx